import { API_GET_ONE_CLIENT_NEGOTIATE_SUCCESS } from '@/actions/ClientRfpNegotiateActions/getOne';
const initialState = {
    one: {},
};
export const clientRfpNegotiateOne = (state = initialState, result) => {
    const { meta, payload, type } = result;
    switch (type) {
        case API_GET_ONE_CLIENT_NEGOTIATE_SUCCESS: {
            const { id = '', view_request_id: viewRequestId = null } = meta.requestPayload;
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [id]: Object.assign(Object.assign({}, state.one[id]), (viewRequestId ? { [viewRequestId]: payload } : {})) }) });
        }
        default: {
            return state;
        }
    }
};
